import './js/jquery-global';
import 'bootstrap';

// keep these scss files as separate modules for faster builds (import here instead of in the global scss)
import './styles/bootstrap.scss';
import './styles/app.scss';

import './js/form';
import './js/components';